// Template198: Bangkok - Mercado Flotante (Día 4). Idéntico a PageMercadoFlotante.jsx. borderRadius: "12px".

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template198 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const titleOverlay = page?.texts?.[2]?.content;
	const trenTitle = page?.texts?.[3]?.content;
	const trenBody = page?.texts?.[4]?.content;
	const yellowBoxText = page?.texts?.[5]?.content;
	const damnoenTitle = page?.texts?.[6]?.content;
	const damnoenBody = page?.texts?.[7]?.content;
	const tipText = page?.texts?.[8]?.content;
	const amphawaTitle = page?.texts?.[9]?.content;
	const amphawaBody = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const trenImage = getImageSrc("tren");
	const damnoenImage = getImageSrc("damnoen");
	const stickerUrl = getCanvasImageUrl("sticker");
	const amphawaStickerUrl = getCanvasImageUrl("amphawa-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#000",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: isSmallScreen ? 24 : 28,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: 60, left: 18 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box sx={{ fontSize: "13px", color: "#333", margin: 0, padding: 0 }}>
						{intro}
					</Box>
				)}
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					<Box data-block-id="text-2" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{trenImage && (
							<Box
								component="img"
								src={trenImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue.length > 0 && (
							<Box sx={{ position: "absolute", top: 10, left: "33%" }}>
								<SabiasQue
									icono={sabiasQue[0]?.icono ?? "🛤️"}
									texto={sabiasQue[0]?.texto ?? ""}
								/>
							</Box>
						)}
						<Box sx={{ width: "60%" }}>
							<Box component="h3" sx={estiloH3}>
								{trenTitle}
							</Box>
							{trenBody && (
								<Box component="p" sx={estiloP}>
									{trenBody}
								</Box>
							)}
						</Box>
					</Box>

					{yellowBoxText && (
						<Box
							data-block-id="text-3"
							sx={{
								backgroundColor: "#FFF3CD",
								border: "3px solid #E8A838",
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: "13px",
								color: "#333",
							}}
						>
							<Box component="p" sx={{ margin: 0, ...estiloP }}>
								{yellowBoxText}
							</Box>
						</Box>
					)}

					<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{damnoenImage && (
							<Box
								component="img"
								src={damnoenImage}
								alt=""
								sx={{
									width: "40%",
									height: 110,
									objectFit: "cover",
									borderRadius: "12px",
								}}
							/>
						)}
						{sabiasQue.length > 1 && (
							<>
								<Box sx={{ position: "absolute", top: 10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[1]?.icono ?? "⏰"}
										texto={sabiasQue[1]?.texto ?? ""}
									/>
								</Box>
								{sabiasQue[2] && (
									<Box sx={{ position: "absolute", top: 52, left: "33%" }}>
										<SabiasQue
											icono={sabiasQue[2]?.icono ?? "🚗"}
											texto={sabiasQue[2]?.texto ?? ""}
										/>
									</Box>
								)}
							</>
						)}
						<Box sx={{ width: "60%" }}>
							<Box component="h3" sx={estiloH3}>
								{damnoenTitle}
							</Box>
							{damnoenBody && (
								<Box component="p" sx={estiloP}>
									{damnoenBody}
								</Box>
							)}
						</Box>
					</Box>

					<Box data-block-id="text-5" sx={{ display: "flex", gap: 2, position: "relative" }}>
						{tipText && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? 100 : 80,
									right: 100,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: 300,
									zIndex: 3,
								}}
							>
								{tipText}
							</Box>
						)}
						{amphawaStickerUrl && (
							<Box
								component="img"
								src={amphawaStickerUrl}
								alt=""
								sx={{
									width: isSmallScreen ? 105 : 105,
									position: "absolute",
									bottom: isSmallScreen ? 70 : 50,
									right: 0,
								}}
							/>
						)}
						<Box
							sx={{
								width: "100%",
								marginTop: isSmallScreen ? 10 : 3,
								marginBottom: isSmallScreen ? 1 : 0,
							}}
						>
							<Box
								component="p"
								sx={{
									...estiloP,
									padding: 1.5,
									backgroundColor: "#fff8db",
									borderRadius: "12px",
								}}
							>
								<Box component="h3" sx={estiloH3}>
									{amphawaTitle}
								</Box>
								{amphawaBody}
							</Box>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template198.thumbnail = "/images/template-1.png";
export default Template198;
